import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { t } from "@/lib/typography";

export function ChapterHeader({
  bookId,
  bookTitle,
  order,
  total,
  completedCount,
}: {
  bookId: number;
  bookTitle: string;
  order: number;
  total: number;
  completedCount: number;
}) {
  const progressPercent = total > 0 ? (completedCount / total) * 100 : 0;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Link
          to={`/books/${bookId}`}
          className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeftIcon className="size-4" />
          {bookTitle}
        </Link>
        <span className={t.meta}>
          Chapter {order} of {total}
        </span>
      </div>
      <Progress value={progressPercent} className="h-2" />
    </div>
  );
}
